import { QuizConfig } from '../../types/quiz';
import image1 from '../../assets/1.png';
import image2 from '../../assets/2.png';
import image3 from '../../assets/3.png';
import image4 from '../../assets/4.png';
import image5 from '../../assets/5.png';
import image6 from '../../assets/6.png';

const lifeExpectancyQuiz: QuizConfig = {
  id: 'life-expectancy',
  title: '기대수명 테스트',
  shortTitle: '기대수명',
  description: '대한민국 평균나이 82세, 당신의 인생시계는 몇 시?',
  icon: '⏰',
  gradient: ['#FFD6FF', '#C9A0DC'],
  headerColor: '#FFD6FF',
  questions: [
    { id: 1, description: '하루에 7-9시간 규칙적으로 잠을 잡니까?', yesScore: 4, noScore: -2 },
    { id: 2, description: '일주일에 두 번 이상 운동합니까?', yesScore: 4, noScore: -2 },
    { id: 3, description: '담배를 피우고 있습니까?', yesScore: -2, noScore: 4 },
    { id: 4, description: '일주일에 두 번 이상 술을 마십니까?', yesScore: -2, noScore: 4 },
    { id: 5, description: '매일 과일과 채소를 먹습니까?', yesScore: 4, noScore: -2 },
    { id: 6, description: '스트레스를 자주 받습니까?', yesScore: -2, noScore: 4 },
    { id: 7, description: '정기적으로 건강 검진을 받습니까?', yesScore: 4, noScore: -2 },
    { id: 8, description: '혈압으로 문제가 있었습니까?', yesScore: -2, noScore: 4 },
    { id: 9, description: '라면,과자 일주일에 한 번 이상 드십니까?', yesScore: -2, noScore: 4 },
    { id: 11, description: '가족 중 심장병이 있습니까?', yesScore: -2, noScore: 4 },
    { id: 12, description: '가족 중 암이 있습니까?', yesScore: -2, noScore: 4 },
    { id: 13, description: '과체중이거나 저체중입니까?', yesScore: -2, noScore: 4 },
    { id: 14, description: '하루에 물을 3잔 이상 마십니까?', yesScore: 4, noScore: -2 },
    { id: 15, description: '빵을 일주일에 두 번 이상 먹습니까?', yesScore: -2, noScore: 4 },
    { id: 18, description: '일주일에 세 번 이상 기름진 음식을 먹습니까?', yesScore: -2, noScore: 4 },
    { id: 19, description: '하루에 8시간 이상 앉아 있습니까?', yesScore: -2, noScore: 4 },
  ],
  explanations: [
    { good: '충분한 수면은 면역력과 두뇌 건강에 필수적입니다. 잘하고 계세요!', bad: '수면 부족은 심혈관 질환, 비만, 우울증 위험을 높입니다.' },
    { good: '규칙적인 운동은 수명을 최대 7년까지 연장시킬 수 있습니다!', bad: '운동 부족은 심장병, 당뇨병 위험을 크게 높입니다.' },
    { good: '비흡연은 폐암 위험을 90% 이상 줄여줍니다!', bad: '흡연은 기대수명을 평균 10년 단축시킵니다.' },
    { good: '절제된 음주 습관이 건강을 지켜줍니다!', bad: '과도한 음주는 간 질환과 각종 암 위험을 높입니다.' },
    { good: '과일과 채소의 항산화 성분이 노화를 늦춰줍니다!', bad: '과일/채소 부족은 비타민 결핍과 면역력 저하를 유발합니다.' },
    { good: '스트레스 관리를 잘 하고 계시네요! 정신 건강이 곧 신체 건강입니다.', bad: '만성 스트레스는 세포 노화를 촉진하고 수명을 단축시킵니다.' },
    { good: '정기 검진으로 질병을 조기 발견하면 생존율이 크게 높아집니다!', bad: '검진을 미루면 치료 가능한 질병도 위험해질 수 있습니다.' },
    { good: '건강한 혈압은 뇌졸중과 심장마비 예방의 핵심입니다!', bad: '고혈압은 \'침묵의 살인자\'로 불리며 합병증 위험이 큽니다.' },
    { good: '가공식품을 절제하는 것은 훌륭한 식습관입니다!', bad: '라면과 과자의 나트륨과 트랜스지방은 혈관 건강을 해칩니다.' },
    { good: '가족력이 없다면 심장 질환 위험이 상대적으로 낮습니다!', bad: '가족력이 있다면 더욱 주의 깊은 건강 관리가 필요합니다.' },
    { good: '가족력이 없다면 암 위험이 상대적으로 낮습니다!', bad: '가족력이 있다면 정기 검진이 특히 중요합니다.' },
    { good: '적정 체중 유지는 장수의 핵심 요소입니다!', bad: '비만과 저체중 모두 기대수명을 단축시킬 수 있습니다.' },
    { good: '충분한 수분 섭취는 신진대사와 해독에 필수적입니다!', bad: '수분 부족은 신장 기능 저하와 피로감을 유발합니다.' },
    { good: '정제 탄수화물 섭취를 줄이는 것은 혈당 관리에 도움됩니다!', bad: '과도한 빵 섭취는 혈당 급상승과 체중 증가를 유발합니다.' },
    { good: '기름진 음식을 절제하면 혈관 건강이 좋아집니다!', bad: '기름진 음식의 과다 섭취는 고지혈증과 동맥경화 위험을 높입니다.' },
    { good: '적절한 활동량을 유지하고 계시네요!', bad: '장시간 좌식 생활은 \'앉아있는 것이 새로운 흡연\'이라 불릴 만큼 위험합니다.' },
  ],
  healthTips: [
    { question: '수면', tip: '매일 같은 시간에 자고 일어나세요. 잠자리에 들기 1시간 전부터 스마트폰을 멀리하면 수면의 질이 크게 개선됩니다.', icon: '😴' },
    { question: '운동', tip: '매일 30분 걷기부터 시작해보세요. 계단 오르기, 스트레칭 등 일상 속 작은 운동도 큰 차이를 만듭니다.', icon: '🏃' },
    { question: '흡연', tip: '금연 후 1년이면 심장병 위험이 절반으로 줄어듭니다. 금연 상담전화 1544-9030을 활용해보세요.', icon: '🚭' },
    { question: '음주', tip: '음주량을 주 1회 이하로 줄여보세요. 무알코올 음료로 대체하는 것도 좋은 방법입니다.', icon: '🍵' },
    { question: '과일/채소', tip: '하루 5가지 색깔의 과일/채소를 먹어보세요. 아침에 바나나 하나, 점심에 샐러드 한 접시부터 시작!', icon: '🥗' },
    { question: '스트레스', tip: '하루 10분 명상이나 심호흡을 해보세요. 스트레스를 기록하는 일기도 도움이 됩니다.', icon: '🧘' },
    { question: '건강검진', tip: '국가건강검진은 무료입니다! 가까운 병원에서 올해 안에 검진을 받아보세요.', icon: '🏥' },
    { question: '혈압', tip: '나트륨 섭취를 줄이고, 칼륨이 풍부한 바나나와 시금치를 자주 드세요.', icon: '❤️' },
    { question: '가공식품', tip: '라면 대신 통곡물 면을, 과자 대신 견과류를 간식으로 선택해보세요.', icon: '🍎' },
    { question: '가족력(심장)', tip: '가족력이 있다면 6개월마다 심장 관련 검진을 받으시는 것이 좋습니다.', icon: '💓' },
    { question: '가족력(암)', tip: '가족력이 있다면 관련 암 검진을 일반인보다 5-10년 일찍 시작하세요.', icon: '🔬' },
    { question: '체중', tip: 'BMI 18.5-24.9를 목표로 식단과 운동을 병행하세요. 급격한 다이어트보다 꾸준한 관리가 중요합니다.', icon: '⚖️' },
    { question: '수분섭취', tip: '스마트폰 알람을 설정해 2시간마다 물 한 잔씩 마셔보세요. 하루 8잔이 목표!', icon: '💧' },
    { question: '빵/정제탄수화물', tip: '흰빵 대신 통밀빵을, 정제 밀가루 대신 잡곡을 선택하면 혈당 관리에 도움됩니다.', icon: '🌾' },
    { question: '기름진 음식', tip: '튀김 대신 굽거나 찜으로 조리하고, 올리브유나 들기름 등 좋은 지방을 선택하세요.', icon: '🥑' },
    { question: '좌식생활', tip: '50분 앉아있으면 10분 일어나서 걸으세요. 서서 일하는 시간을 하루 1시간씩 늘려보세요.', icon: '🧍' },
  ],
  categories: [
    { name: '생활습관', color: '#4CAF50', indices: [0, 1] },
    { name: '식습관', color: '#FF9800', indices: [4, 8, 12, 13, 14] },
    { name: '유해습관', color: '#f44336', indices: [2, 3] },
    { name: '건강관리', color: '#2196F3', indices: [6, 7, 11] },
    { name: '가족력', color: '#9C27B0', indices: [9, 10] },
    { name: '정신건강', color: '#00BCD4', indices: [5, 15] },
  ],
  resultTiers: [
    { maxScore: 5, title: 'YOLO 인생 실전편', emoji: '💀', image: image1 },
    { maxScore: 10, title: '몸이 보내는 SOS', emoji: '🆘', image: image2 },
    { maxScore: 15, title: '평균은 간다', emoji: '😏', image: image3 },
    { maxScore: 20, title: '건강 유망주', emoji: '💪', image: image4 },
    { maxScore: 25, title: '장수 명가 후손', emoji: '👑', image: image5 },
    { maxScore: Infinity, title: '신선급 불로장생', emoji: '🐉', image: image6 },
  ],
  baseValue: 84,
  resultUnit: '살',
  resultPrefix: '당신은 ',
  resultSuffix: '까지,,',
  percentile: { mean: 16, sd: 15 },
  seo: {
    title: '기대수명 테스트 - 나의 기대수명은?',
    description: '대한민국 평균나이 82세, 당신의 인생시계는 몇 시? 16가지 건강 질문으로 기대수명을 알아보세요!',
  },
};

export default lifeExpectancyQuiz;
